module.exports = __webpack_public_path__ + "img/9.988e7e32.png";